import React from 'react';
import { ClipboardList, LifeBuoy, Layers } from 'lucide-react';

/**
 * "How long does this take to stand up?" is the first objection on every
 * Solutions page. We deliberately do not answer it with a number — there
 * isn't one we can stand behind across plans, hubs and CBOs — so we answer
 * it with what actually happens instead.
 */
const GettingStarted: React.FC = () => (
  <section className="py-16 bg-gray-50 dark:bg-gray-900 border-t border-gray-200 dark:border-gray-800">
    <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
      <h2 className="text-2xl md:text-3xl font-bold text-ink mb-3 text-center">
        What getting started looks like
      </h2>
      <p className="text-base text-gray-600 dark:text-gray-300 text-center max-w-2xl mx-auto mb-10">
        You are not starting from a blank system. Most of what you need already
        exists and is configured for you.
      </p>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div className="bg-white dark:bg-gray-950 rounded-xl border border-gray-200 dark:border-gray-800 p-6">
          <ClipboardList className="w-6 h-6 text-v2accent mb-3" />
          <h3 className="font-bold text-gray-800 dark:text-gray-100 mb-1.5">
            Streamlined onboarding
          </h3>
          <p className="text-sm text-gray-600 dark:text-gray-300">
            We set up your organization, programs and users with you, rather than
            handing over a manual.
          </p>
        </div>

        <div className="bg-white dark:bg-gray-950 rounded-xl border border-gray-200 dark:border-gray-800 p-6">
          <Layers className="w-6 h-6 text-v2accent mb-3" />
          <h3 className="font-bold text-gray-800 dark:text-gray-100 mb-1.5">
            Templates already built
          </h3>
          <p className="text-sm text-gray-600 dark:text-gray-300">
            Forms, screenings, referral workflows and reports come from working
            programs, so you adapt them instead of authoring them.
          </p>
        </div>

        <div className="bg-white dark:bg-gray-950 rounded-xl border border-gray-200 dark:border-gray-800 p-6">
          <LifeBuoy className="w-6 h-6 text-v2accent mb-3" />
          <h3 className="font-bold text-gray-800 dark:text-gray-100 mb-1.5">
            Real-time support
          </h3>
          <p className="text-sm text-gray-600 dark:text-gray-300">
            Your team reaches a person who knows your configuration, not a queue.
          </p>
        </div>
      </div>

      <p className="text-center text-sm text-gray-600 dark:text-gray-300 mt-10">
        For a demo, write to{' '}
        <a href="mailto:welcome@weavein.ai" className="text-v2accent hover:underline">
          welcome@weavein.ai
        </a>
        .
      </p>
    </div>
  </section>
);

export default GettingStarted;
